import WBS from 'js/http';

export default {
	data() {
		return {
			tmp: [],
		};
	},
	methods: {
		printPPRA(data) {
			this.generateDocument(data, 'ppra', 16);
		},

		generateDocument(data, loader, tmp) {
			const sData = {
				data: {
					data: data,
					tmp: this.tmp.find((e) => e.cod == tmp),
				},
				loader: loader,
			};
			WBS.send('protected-custom-replaceDocument', sData, (resp) => {
				console.log(resp);
			});
		},
	},
	mounted() {
		WBS.send('protected-read-gridTemplates', (resp) => {
			this.tmp = resp.data;
		});
	},
};



// WEBPACK FOOTER //
// ./src/components/sst/seguranca/mixins/print.js